import { render, staticRenderFns } from "./ClassList.vue?vue&type=template&id=7cb4a99a&scoped=true"
import script from "./ClassList.vue?vue&type=script&lang=js"
export * from "./ClassList.vue?vue&type=script&lang=js"
import style0 from "./ClassList.vue?vue&type=style&index=0&id=7cb4a99a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb4a99a",
  null
  
)

export default component.exports